import { useConfigurationStore } from '@/stores/configuration';
import { canParseAsUrl } from '@/utils/parse-url';

export function getPreviewableUrl(src: string) {
  if (!canParseAsUrl(src)) return src;
  if (src.startsWith('blob:')) return src;

  return `${src}#t=0.001`;
}

export function getSafeMediaUrl(src: Nullable<string>, baseUrl?: string): string {
  if (!src) return '';

  baseUrl ??= useConfigurationStore.getState().endpoint.FILE_ENDPOINT;

  if (!baseUrl) return src;
  if (src.startsWith('blob')) return src;
  if (src.startsWith('data')) return src;
  if (!src.startsWith('http')) return new URL(src, baseUrl).href;

  const original = new URL(src);

  return new URL(`${original.pathname}${original.search}`, baseUrl).href;
}

export function getPosterUrl(src: string, baseUrl?: string) {
  if (!canParseAsUrl(src)) return;

  const url = new URL(src);
  if (!url.protocol.startsWith('http')) return;

  const newPath = url.pathname.replace(/\..*$/, '.jpg') + url.search;

  return getSafeMediaUrl(new URL(newPath, url.origin).href, baseUrl);
}
